import { useEffect } from 'react';

import { isSessionExpired } from '@/client/mgmtPlane';
import { useMessage } from '@/hooks/message';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';

export type ShowErrorMessageProps = {
  showError: boolean;
  errorMessage?: string;
};

export function useShowErrorMessage({ showError, errorMessage }: ShowErrorMessageProps) {
  const [message] = useMessage();
  const { t } = useMimicTranslation('global');

  const displayedErrorMessage = errorMessage || t('ops');

  useEffect(() => {
    if (showError && !isSessionExpired()) {
      message.error(displayedErrorMessage);
    }
  }, [showError, message, displayedErrorMessage]);

  return message.error;
}
